<template>
<FilterMe @onSubmit="filterMe" :filters="filters">
    <template #form="{filters}">
        <CRow>
            <CCol col="12">
                <CInput v-model="filters.subject" :placeholder="$t('ticket.subject')" />
            </CCol>
            <CCol col="12">
                <div role="group" class="form-group datepicker">
                    <datePicker :placeholder="$t('attributes.created_from')" :clearable="true" format="YYYY-MM-DD HH:mm:ss" display-format="dddd jDD jMMMM jYYYY" input-class="form-control" v-model="filters.min_created_at" type="datetime" />
                </div>
            </CCol>
            <CCol col="12" v-if="$policy('ticket').view_any_or_group">
                <CInput v-model="filters.created_for.full_name" :placeholder="$t('ticket.created_for')" />
            </CCol>
            <CCol col="12" v-if="$policy('ticket').view_any_or_group">
                <CInput v-model="filters.responsible.full_name" :placeholder="$t('user.email')" />
            </CCol>
            <CCol col="12">
                <CSelect2 addInputClasses="font-xs" v-model="filters.status" :options="ticketStatusOptionWithNull" ignoreOptionStyle />
            </CCol>
        </CRow>
    </template>
</FilterMe>
</template>

<script>

import { mapActions } from 'vuex'
import { ticketStatusOptionWithNull } from '@/common/data'

export default {
    name: 'FilterIt',

    data() {
        return {
            ticketStatusOptionWithNull,
            filters: {
                subject: '',
                status: '',
                min_created_at: '',
                created_for: {
                    full_name: ''
                },
                responsible: {
                    full_name: ''
                }
            }
        }
    },

    methods: {
        ...mapActions({
            fetch: 'ticket/fetch'
        }),
        filterMe(filters) {
            this.fetch({
                page: 1,
                ...filters
            })
        }
    }
}
</script>